import {Button} from '@mui/material';
import React from 'react';

import {AlertInfo} from 'presentation/components';
import {ContentState} from 'presentation/components/ContentState';
import {translations} from 'presentation/translations-new';
import {AppointmentsListContainer} from './styles';
import {EmptyAppointmentsListProps} from './types';

const {
	newAppointment,
	emptyAppointment,
	telehealthDocumentsAccess: {myAppointmentsAlert},
} = translations['pt-br'].privateFlow.myAppointments;

export function EmptyAppointmentsList({
	description,
	hideButton,
	hideAlertInfo,
	handleNewAppointment,
}: EmptyAppointmentsListProps) {
	return (
		<AppointmentsListContainer>
			{hideAlertInfo ? null : (
				<AlertInfo.Root sx={{mb: 2}}>
					<AlertInfo.Description>{myAppointmentsAlert}</AlertInfo.Description>
				</AlertInfo.Root>
			)}
			<ContentState
				description={description}
				title={emptyAppointment.title}
				customIconName="calendar-alert"
				footer={
					hideButton ? null : (
						<Button onClick={handleNewAppointment} variant="contained" size="large">
							{newAppointment}
						</Button>
					)
				}
			/>
		</AppointmentsListContainer>
	);
}
